import styles from './IconDefault.module.scss';

export function IconChart() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M30.9737 4.27734C29.5051 4.27734 28.3146 5.47421 28.3146 6.95061V33.6833C28.3146 35.1597 29.5051 36.3565 30.9737 36.3565H33.6328C35.1014 36.3565 36.2919 35.1597 36.2919 33.6833V6.95061C36.2919 5.47421 35.1014 4.27734 33.6328 4.27734H30.9737ZM16.3496 12.2963C16.3496 10.8199 17.5401 9.62305 19.0087 9.62305H21.6678C23.1364 9.62305 24.3269 10.8199 24.3269 12.2963V33.6824C24.3269 35.1588 23.1364 36.3557 21.6678 36.3557H19.0087C17.5401 36.3557 16.3496 35.1588 16.3496 33.6824V12.2963ZM4.38281 22.9897C4.38281 21.5133 5.57333 20.3164 7.0419 20.3164H9.70099C11.1696 20.3164 12.3601 21.5133 12.3601 22.9897V33.6827C12.3601 35.1591 11.1696 36.356 9.70099 36.356H7.0419C5.57333 36.356 4.38281 35.1591 4.38281 33.6827V22.9897Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<circle
				cx="14.5625"
				cy="28.4551"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="34.3906"
				cy="13.3164"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="34.3906"
				cy="16.3164"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="34.3906"
				cy="19.3164"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M3.6335 33.9688C4.08945 34.3424 4.67253 34.5666 5.30797 34.5666H7.95188C9.41207 34.5666 10.5958 33.3829 10.5958 31.9227V21.347C10.5958 19.8868 9.41207 18.7031 7.95188 18.7031H5.30797C3.84778 18.7031 2.66406 19.8868 2.66406 21.347V29.9838"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M14.5625 31.9241C14.5625 33.3843 15.7462 34.568 17.2064 34.568H19.8503C21.3105 34.568 22.4942 33.3843 22.4942 31.9241V10.7728C22.4942 9.31263 21.3105 8.12891 19.8503 8.12891H17.2064C15.7462 8.12891 14.5625 9.31263 14.5625 10.7728V24.6875"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M34.3907 10.0625V5.48375C34.3907 4.02356 33.207 2.83984 31.7468 2.83984H29.1029C27.6427 2.83984 26.459 4.02356 26.459 5.48375V31.9229C26.459 33.383 27.6427 34.5668 29.1029 34.5668H31.7468C33.207 34.5668 34.3907 33.383 34.3907 31.9229C34.3907 31.9229 34.3907 27.0205 34.3907 23.0625"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}

// #4577AC => var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))
// #CEDDE5 => var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))
